import { BusinessUnitTypes, BusinessUnitHierarchyTypes } from "types/enums";

export const residualsStatus = {
	PayResiduals: "0",
	WithholdResiduals: "1",
};

export const getDefaultResidualsStatus = partnerStatus => {
	if (partnerStatus?.name === "ActivatedAgent" || partnerStatus === "3") {
		return residualsStatus.PayResiduals;
	} else if (
		partnerStatus?.name === "InactiveAgent" ||
		partnerStatus === "4"
	) {
		return residualsStatus.PayResiduals;
	} else if (
		partnerStatus?.name === "ProspectiveAgent" ||
		partnerStatus === "2"
	) {
		return residualsStatus.WithholdResiduals;
	} else if (
		partnerStatus?.name === "TerminatedAgent" ||
		partnerStatus === "1"
	) {
		return residualsStatus.WithholdResiduals;
	} else {
		return undefined;
	}
};

export const partnerStatus = {
	terminatedAgent: 1,
	prospectiveAgent: 2,
	activatedAgentPartner: 3,
	inactiveAgent: 4,
};

export const getBusinessUnitHierarchyItems = businessUnit => {
	if (businessUnit?.name === BusinessUnitTypes.Aurora.name) {
		return [
			BusinessUnitHierarchyTypes.InsideSales,
			BusinessUnitHierarchyTypes.Legacy,
			BusinessUnitHierarchyTypes.CrossSellOrRetention,
		];
	} else if (businessUnit?.name === BusinessUnitTypes.OnePayment.name) {
		return [
			BusinessUnitHierarchyTypes.InsideSalesOnePayment,
			BusinessUnitHierarchyTypes.LegacyOnePayment,
			BusinessUnitHierarchyTypes.CrossSellOrRetentionOnePayment,
		];
	} else if (businessUnit?.name === BusinessUnitTypes.VnSystems.name) {
		return [
			BusinessUnitHierarchyTypes.InsideSalesVnSystems,
			BusinessUnitHierarchyTypes.LegacyVnSystems,
			BusinessUnitHierarchyTypes.CrossSellOrRetentionVnSystems,
		];
	} else if (
		businessUnit?.name === BusinessUnitTypes.BusinessDevelopment.name
	) {
		return [
			BusinessUnitHierarchyTypes.ISOs,
			BusinessUnitHierarchyTypes.ISVs,
			BusinessUnitHierarchyTypes.ThirdPartyProducts,
			BusinessUnitHierarchyTypes.Associations,
		];
	} else if (businessUnit?.name === BusinessUnitTypes.Acquisition.name) {
		return [BusinessUnitHierarchyTypes.NailSoft];
	} else {
		return BusinessUnitHierarchyTypes.getOptions();
	}
};
